import { render } from "./DetailsEditForm.vue?vue&type=template&id=410eb39b"
import script from "./DetailsEditForm.vue?vue&type=script&lang=js"
export * from "./DetailsEditForm.vue?vue&type=script&lang=js"

import "./DetailsEditForm.vue?vue&type=style&index=0&id=410eb39b&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__